import React, { MouseEvent } from "react";
import "./ResultPopup.css";
import { usePopup } from "src/contexts/PopupContext";

const ResultPopup: React.FC = () => {
  const {
    isResultPopupVisible,
    resultPopupHeader,
    resultPopupText,
    setIsResultPopupVisible,
  } = usePopup();

  const hideForm = (event: MouseEvent<HTMLDivElement>) => {
    if (event.target !== event.currentTarget) return;
    setIsResultPopupVisible(false);
  };

  const handleCloseButton = () => {
    setIsResultPopupVisible(false);
  };

  return (
    <>
      {isResultPopupVisible && (
        <div className="result-popup" onClick={hideForm}>
          <div>
            <div className="close-result" onClick={handleCloseButton}>
              ×
            </div>
            {resultPopupHeader && <h2>{resultPopupHeader}</h2>}
            {resultPopupText && <p>{resultPopupText}</p>}
            <button onClick={handleCloseButton}>Ok</button>
          </div>
        </div>
      )}
    </>
  );
};

export default ResultPopup;
